import { useEffect } from 'react'

import { useIsJobFinished, useTranscriptMetadata } from 'src/contexts/Transcript/MetadataContext'
import { usePrevious } from 'src/hooks/usePrevious'
import { useToastWithAnnouncement } from 'src/hooks/useToastWithAnnouncement'
import { isChromakeyModeActive, isMockAutoRefreshRequested } from 'src/utils/env'

export const useStreamConcludedCheck = () => {
    const isCurrentJobFinished = useIsJobFinished()
    const wasCurrentJobFinished = usePrevious(isCurrentJobFinished)
    const showToast = useToastWithAnnouncement()
    const transcriptMetadata = useTranscriptMetadata()
    useEffect(() => {
        if (!wasCurrentJobFinished && isCurrentJobFinished && !isChromakeyModeActive && transcriptMetadata?.viewMode === 'job') {
            const shouldAutoRefresh = isMockAutoRefreshRequested()
            const duration = 5000
            showToast({
                type: 'info',
                title: 'Stream concluded. Thank you for joining!',
                description: shouldAutoRefresh
                    ? `Autoplay will be restarted automatically in ${Math.round(duration / 1000)} seconds...`
                    : '',
                duration,
                onCloseComplete: () => {
                    if (shouldAutoRefresh) {
                        window.location.reload()
                    }
                },
            })
        }
    }, [isCurrentJobFinished, showToast, transcriptMetadata?.viewMode, wasCurrentJobFinished])
}
